import type { CompRef } from 'types/documentServices';
import experiment from 'experiment';

import type { EditorAPI } from '#packages/editorAPI';
import constants from '#packages/constants';
import { getSlotOpenerUserPreferences } from './slotOpenerUserPreferences';

const containerWhitelist = [
  constants.COMP_TYPES.FOOTER,
  constants.COMP_TYPES.SECTION,
  constants.COMP_TYPES.CONTAINER,
  constants.COMP_TYPES.STRIP_COLUMNS_CONTAINER,
  constants.COMP_TYPES.COLUMN,
];

const ancestorBlacklist = [
  constants.COMP_TYPES.REPEATER,
  constants.COMP_TYPES.HEADER,
];

const isSlotOpenerDisabledInTools = (editorAPI: EditorAPI) => {
  const isSlotOpenerEnabled = getSlotOpenerUserPreferences(editorAPI);

  return !isSlotOpenerEnabled;
};

const isSlotOpenerEnabled = (
  editorAPI: EditorAPI,
  draggedComponent?: CompRef,
) => {
  if (isSlotOpenerDisabledInTools(editorAPI)) {
    return false;
  }

  if (draggedComponent) {
    const containerType = editorAPI.components.getType(
      editorAPI.components.getContainer(draggedComponent),
    );

    const isAncestorBlacklisted = !!editorAPI.components.findAncestor(
      draggedComponent,
      (compOrAncestorRef) =>
        ancestorBlacklist.includes(
          editorAPI.components.getType(compOrAncestorRef),
        ),
    );

    if (isAncestorBlacklisted || !containerWhitelist.includes(containerType)) {
      return false;
    }
  }

  return (
    editorAPI.isMobileEditor() &&
    (experiment.isOpen('se_slotOpener') ||
      experiment.isOpen('se_slotOpenerV2') ||
      experiment.isOpen('se_slotOpenerV3'))
  );
};

export { isSlotOpenerEnabled };
